<template>
  <div class="bg-light-blue">
    <SiteHeader/>

    <main class="reset-pwd">
      <div class="container">
        <div class="row">
          <div class="col-md-9 col-lg-7 col-xl-6 col-xxl-5 m-auto">
            <div class="reset-pwd-content">
              <validation-observer ref="form">
                <form @submit.prevent="reset">
                  <h1 class="text-center">Forgot Password</h1>
                  <div v-if="!resetDone">
                    <div class="form-group mt-5">
                      <label for="email">Email</label>
                      <input type="email" id="email" v-model="form.email" placeholder="Enter your email" />
                      <validation-provider name="email" v-slot="{ errors }">
                        <div class="invalid-feedback" style="display: block">{{ errors[0] }}</div>
                      </validation-provider>
                    </div>
                    <div class="form-group">
                      <button type="submit" class="main-btn d-block w-100">Request Reset Link</button>
                    </div>
                    <div class="form-footer text-center">
                      <p class="mb-2">Remembered password?</p>
                      <router-link :to="{name: 'login'}" class="fw-bold text-decoration-underline">Log in</router-link>
                    </div>
                  </div>
                  <div class="mt-5" v-else>
                    <p>The link was emailed to you. Follow it to reset the password.</p>
                  </div>
                </form>
              </validation-observer>
            </div>
          </div>
        </div>
      </div>
    </main>

    <SiteFooter/>
  </div>
</template>

<script>
import SiteHeader from "@/components/partials/SiteHeader"
import SiteFooter from "@/components/partials/SiteFooter"

import API from "@/api"
const api = new API()
export default {
  name: 'Forgot',
  components: {SiteFooter, SiteHeader},
  data() {
    return {
      form: {
        email: ''
      },
      resetDone: false
    }
  },
  methods: {
    reset() {
      this.$refs.form.reset()

      this.$wait.start('reset_password')
      api.requestPasswordReset(this.form.email)
        .then(() => {
          this.resetDone = true
          setTimeout(() => {
            this.$router.push({name: 'login'})
          }, 3000)
        })
        .catch(r => this.$refs.form.setErrors(r.response.data))
        .finally(() => this.$wait.end('reset_password'))
    },
  }
}
</script>

<style scoped>
@import '/public/css/reset-pwd.css';
</style>
